import { FCSEOUL_RUN_QNA_CATEGORY } from 'src/app/(championsrun)/_constants/route';
import { PEPERO_LABEL_QNA_CATEGORY } from 'src/app/(pepero-label)/pepero-label/_components/constants';

// 목록까지 고정(categoryName)하는 문의유형 허용 목록.
// 작성 화면의 유형 고정(?category=)은 기존처럼 모든 브랜드에 동작하고,
// 목록 고정과 '고정 상태로 작성 후 고정 목록 복귀'는 여기 있는 유형에만 적용한다(설레임런 등 기존 브랜드 영향 없음).
const LIST_LOCKABLE_QNA_CATEGORIES: readonly string[] = [FCSEOUL_RUN_QNA_CATEGORY, PEPERO_LABEL_QNA_CATEGORY];

export const isListLockableQnaCategory = (name: string | null | undefined): name is string =>
  !!name && LIST_LOCKABLE_QNA_CATEGORIES.includes(name);
